import React from 'react';
import { useSelector } from 'react-redux';
import { ComponentWithEntriesCheck, Roles } from '@cambridgeassessment/lib-ee-commons';
import { StyledContainer } from '../../Content.styles';
import { RootState } from '../../../../store';
import Loader from '../../../../components/Loader/Loader';
import ComponentFC from './ComponentFC';

const Assessments: React.FC<{}> = () => {
  const { isLoading, components, hasError } = useSelector((state: RootState) => state.components);
  const { selectedRole } = useSelector((state: RootState) => state.userData);

  const isUserSuperAdmin = selectedRole?.name === Roles.SUBMIT_SUPER_ADMIN;

  if (isLoading) return <Loader />;

  if (hasError) return <div>Failed to get assessment components data</div>;

  if (!components || !components.length) return <div>No components were found</div>;

  return (
    <StyledContainer>
      {components &&
        components.map((component: ComponentWithEntriesCheck, index: number) => (
          <ComponentFC
            key={`${component.name}-${index}`}
            component={component}
            index={index}
            disabled={!isUserSuperAdmin}
            hideSections
          />
        ))}
    </StyledContainer>
  );
};

export default Assessments;
